Namespace 'Settings.Models.Topics.InstagramBusiness'

class Settings.Models.Topics.InstagramBusiness.ValidateInstagramUsername extends Backbone.Model
  urlRoot: '/keepcon/topics/validate_instagram_username'

  defaults:
    username_is_valid: false

  initialize: (socialAccountId) ->
    @socialAccountId = socialAccountId
